import type {CompStructure, Pointer, PS} from '@wix/document-services-types'
import siteWidth from '../../structure/siteWidth/siteWidth'
import {convertCompToNewSiteWidth} from '../../structure/siteWidth/siteWidthConversion'
import type {ComponentAfterRootAddDataFromExtEvent} from '@wix/document-manager-extensions/dist/src/extensions/components/hooks'

const convertCompToNewSiteWidthHook = (ps: PS, comp: Pointer, container: Pointer, compDefinition: CompStructure) => {
    if (ps.siteAPI.isMobileView()) return

    const componentSerializedSiteWidth = compDefinition?.siteWidth ?? 980
    const currentSiteWidth = siteWidth.getSiteWidth(ps)

    if (componentSerializedSiteWidth === currentSiteWidth) return

    return convertCompToNewSiteWidth(ps, comp, null, componentSerializedSiteWidth, currentSiteWidth)
}

const rconvertCompToNewSiteWidthHookFromExt = (ps: PS, data: ComponentAfterRootAddDataFromExtEvent) => {
    const {compToAddPointer, containerPointer, componentDefinition} = data
    convertCompToNewSiteWidthHook(ps, compToAddPointer, containerPointer, componentDefinition)
}
export {convertCompToNewSiteWidthHook, rconvertCompToNewSiteWidthHookFromExt}
